import { runCloudFunction } from '@/store/parseUtils'
import { assignmentModule } from '@/store/assignment/module'
import { examMetadataModule } from '@/store/examMetadata/module'
import type { Study } from '@pocketprep/types'

const fetchAssignment = async (prebuiltQuizId: string) => {
    const currentExam = examMetadataModule.getters.getCurrentExamMetadata()

    if (!currentExam) {
        throw new Error('No current exam found')
    }

    const prebuiltQuizData = await runCloudFunction<Study.Cloud.fetchPrebuiltQuizQuestions>(
        'fetchPrebuiltQuizQuestions',
        {
            prebuiltQuizId: prebuiltQuizId,
            includeMPMCQuestions: true,
            includeBuildListQuestions: true,
        }
    )

    let quizQuestions: Study.Class.QuestionJSON[]

    if ('questions' in prebuiltQuizData) {
        quizQuestions = prebuiltQuizData.questions

        assignmentModule.state.assignment = prebuiltQuizData.prebuiltQuiz
        assignmentModule.state.assignmentQuestions = quizQuestions
    } else {
        // if fetch quiz returns a quiz object, then just return it and dont start a quiz
        assignmentModule.state.completedAssignment = prebuiltQuizData
    }
    return
}

const resetAssignmentState = () => {
    assignmentModule.state.assignment = null
    assignmentModule.state.assignmentQuestions = []
    assignmentModule.state.completedAssignment = null
    return
}

export default {
    fetchAssignment,
    resetAssignmentState,
}
